import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin, Observable, of, switchMap } from 'rxjs';
import { AuthService } from 'src/app/_services/auth/auth.service';
import { BlService } from 'src/app/_services/bl/bl.service';
import { LoteService } from 'src/app/_services/lote/lote.service';
import { LoteCabotajeService } from 'src/app/_services/loteCabotaje/lote-cabotaje.service';
import { ScaleTicketService } from 'src/app/_services/scale-ticket/scale-ticket.service';
import { TonsPerYardService } from 'src/app/_services/tons-per-yard/tons-per-yard.service';
import { BlDetails, ExportBoats, TableConfig } from 'src/app/interfaces/bl.interfaces';
import { BatchesAvailableTransfer, ExportOutput, ExportOutputType, ExportTransportOutput } from 'src/app/interfaces/exportationBatches.interfaces';
import { LocationInterface, NationalPorts, SalidaCatalogo, TranportLine } from 'src/app/interfaces/lotes.interfaces';
import { OriginTicket } from 'src/app/interfaces/scale-ticket.interfaces';
import { TonsPerYard } from 'src/app/interfaces/tons-per-yard.interfaces';
interface infoSalida {
  id:         number;
  tipoSalida: number;
}
/**
 * Componente de página que lista las salidas de un lote de cabotaje, permitiendo consultarlas,
 * editarlas, eliminarlas y descargar sus documentos según el tipo de salida.
 */
@Component({
  selector: 'app-cabotaje-lote-salida-lista',
  templateUrl: './cabotaje-lote-salida-lista.component.html',
  styles: [`
    .totales {
      width: 100%;
      padding: 0 10px 5px 0;
    }
    .table-row {
      background-color: #455660;
      color: #fff;
    }
  `]
})
export class CabotajeLoteSalidaListaComponent implements OnInit {
  table_config: TableConfig = {
    tableHeads: [
      ['No. operación', 'id'],
      ['Tipo de salida', 'outputDescription'],
      ['Destino', 'destination_id'],
      ['No. de barco', 'ship_number'],
      ['Nombre del barco', 'ship_name'],
      ['Fecha de salida', 'departure_date'],
      ['Checador', 'checker_name'],
      ['Tonelaje total', 'total_tonnage']
    ],
    tableHeadsContainer: ['Documento', 'Detalle', 'Editar', 'Eliminar'],
    styles: {
      table_heads: {
        'grid-template-columns': 'repeat(8, minmax(110px, 1fr)) minmax(250px, 1fr)',
        'min-width': '1130px',
        'margin': '0',
        'padding': '0',
      },
      table_row: {
        'grid-template-columns': 'repeat(8, minmax(110px, 1fr)) minmax(250px, 1fr)',
        'min-width': '1130px',
      },
      table_row_totals: {
        'grid-template-columns': 'repeat(8, minmax(110px, 1fr)) minmax(250px, 1fr)',
        'min-width': '1130px',
        'background-color': '#455660',
        'color': '#fff',
      },
      container_icons: {
        'grid-template-columns': 'repeat(4, 1fr)',
      }
    },
    arrayFields: [
      'id',
      'outputDescription',
      'destination_id',
      'ship_number',
      'ship_name',
      'departure_date',
      'checker_name',
      'total_tonnage'
    ],
    iconos: [["/eliminar-salida", "id", 'bi bi-download'], ["/detalle-salida", "id", 'bi bi-eye'],["/actualizar-salida", "id", 'bi bi-pencil-square'], ["/eliminar-entry-export", "id", 'bi bi-trash3']],
    mensaje: "Sin salidas asignadas.",
    filter: true,
    groupByField: 'departure_date',
    totalField: 'total_tonnage',
    subtotalField: 'checker_name',
    totals: {
      show: true,
      content: ['', '', '', '', '', '', 'Totales:', 'total'],
      total: 0,
    }
  };
  containerStyles = {
    'grid-template-columns': 'repeat(3, 1fr)'
  };
  overlay: boolean = false;
  mensaje: string = '';
  icon: string = '';
  overlayError: boolean = false;
  overlaySalida: boolean = false;
  subtitulo: string = '';
  movimiento: string = '';
  loader: boolean = true;
  file: boolean = false;
  bacthId: number = 0;
  loading: boolean = false;
  salidaEliminar: boolean = false;
  cuurentOutputId: number = 0;
  archivos = {
    documento: '',
    oficioMerma: '',
    acuerdoAduanal: ''
  };
  outputDetail: ExportOutput[] = [];
  nationalPorts: NationalPorts[] = [];
  locations: LocationInterface[] = [];
  amountsPerYardList: TonsPerYard[] = [];
  outputTypes: ExportOutputType[] = [];
  boats: any[] = [];
  transportType: SalidaCatalogo[] = [];
  unitType: SalidaCatalogo[] = [];
  listTransportLine: TranportLine[] = [];
  originsTicket: OriginTicket[] = [];
  transportList: ExportTransportOutput[] = [];
  tipoSalida: number = 0;
  loaderOverlay: boolean = false;
  batchesAvailableTransfer: BatchesAvailableTransfer[] = [];
  message: string = '';
  operation_number: number = 0;
  blDetails: BlDetails = {
    operation_number:     0,
    boats_name:           '',
    operation_type_number:0,
    bl_tonnage:           0,
    customer_name:        null,
    date_time_capture:    '',
    dock_name:            '',
    port_origin_name:     '',
    start_operations:     '',
    end_operations:       '',
    boat_nationality:     '',
    destination_port:     '',
    operation_id:         0,
    docking_date:         '',
    undocking_date:       '',
    bl_master:            '',
    notice_of_readiness:  '',
    remaining_tonnage:    0,
    output_total_tonnage: 0,
    operation_type:       '',
  };

  get outputs() {
    return this.loteCabotaje.cabotageOutputsFilter;
  }

  constructor(
    private authService: AuthService,
    private loteService: LoteService,
    private loteCabotaje: LoteCabotajeService,
    private amountsPerYardSvc: TonsPerYardService,
    private router: Router,
    private blService: BlService,
    private scaleTicketSvc: ScaleTicketService,
  ) { }

  ngOnInit(): void {
    const parts = this.router.url.split("/");
    this.bacthId = Number(parts[parts.length - 1]);
    if (this.router.url.includes('ship-list')) {
      const currentUrl = this.router.url;
      const match = currentUrl.match(/\/ship-list\/(\d+)/);
      if (match) {
        this.operation_number = Number(match[1]);
      } else {
        this.loader = false;
        this.overlayError = true;
      }

      this.blService.getBlId(this.operation_number)
      .subscribe({
        next: (bldetails) => {
          if (!Array.isArray(bldetails) || !bldetails.length) {
            this.loader = false;
            this.overlayError = true;
            return;
          }
          this.blDetails = bldetails[0];
          this.getDataForOutputs(true);
        },
        error: (e) => {
          this.loader = false;
          this.overlayError = true;
        },
      });
    } else {
      this.getDataForOutputs(false);
    }
  }

  /**
   * Carga en paralelo las salidas del lote y los catálogos requeridos para su gestión.
   * @param importCabotage - Indica si el flujo corresponde a un cabotaje de importación por barco.
   */
  getDataForOutputs(importCabotage: boolean) {
    forkJoin([
      this.loteCabotaje.getListByBatchCabotageOutput(this.bacthId),
      this.loteService.getNationalPorts(),
      this.loteService.getExportOutputTypes(),
      this.getboats(importCabotage),
      this.loteCabotaje.getBatchesAvailableTransfer(this.bacthId),
      this.loteService.getTipoTransporte(),
      this.loteService.getTipoUnidad(),
      this.loteService.getListTransportLine(),
      this.scaleTicketSvc.getOriginsTicket(),
      this.loteService.getLocations(),
      this.amountsPerYardSvc.getTonsPerYardList(3, Number(this.bacthId)),
    ]).subscribe({
      next: ([
        outputs,
        nationalPorts,
        outputTypes,
        boats,
        batchesAvailableTransfer,
        transportType,
        unitType,
        listTransportLine,
        originsTicket,
        locations,
        amountsPerYardList
      ]) => {
        this.nationalPorts = [...nationalPorts];
        this.outputTypes = [...outputTypes];
        if (outputs.length) {
          outputs = this.idToName(outputs);
          // outputs = this.fieldDate(outputs);
        }
        this.updateTotals(outputs);
        outputs = [...this.sortArrayDesc<ExportOutput>(outputs, 'id')];
        this.loteCabotaje.cabotageOutputs = [...outputs];
        this.loteCabotaje.cabotageOutputsFilter = [...outputs];
        this.boats = [...boats];
        this.batchesAvailableTransfer = this.sortArrayDesc<BatchesAvailableTransfer>(batchesAvailableTransfer, 'id');
        this.transportType = this.sortArray<SalidaCatalogo>(transportType.filter( t => t.id !== 2), 'description');
        this.unitType = this.sortArray<SalidaCatalogo>(unitType, 'description');
        this.listTransportLine = this.sortArray<TranportLine>(listTransportLine, 'description');
        this.originsTicket = this.sortArray<OriginTicket>(originsTicket, 'description');
        this.locations = this.sortArray<LocationInterface>(locations, 'description');
        this.amountsPerYardList = [...amountsPerYardList];
        this.loader = false;
      },
      error: (e) => {
        this.loader = false;
        this.overlayError = true;
      },
    });
  }

  /**
   * Obtiene la lista de embarcaciones según el contexto del flujo.
   * @param importCabotage - Indica si se debe usar la embarcación del BL de importación o consultar el catálogo.
   * @returns Un observable con la lista de embarcaciones.
   */
  getboats(importCabotage: boolean) {
    if (importCabotage) {
      const boats: ExportBoats[] = [
        {
          boats_number: this.blDetails.operation_number,
          boats_name: this.blDetails.boats_name,
          date: new Date().toISOString()
        }
      ]
      return of(boats)
    }
    return this.scaleTicketSvc.getBoatsByModule(3)
  }

  /**
   * Verifica los permisos y prepara la confirmación para eliminar una salida.
   * @param id - Identificador de la salida a eliminar.
   */
  confirm(id: number) {
    if (!this.authService.isValidPath('cabotage', 'outputs', 'delete')) {
      return;
    }
    this.cuurentOutputId = id;
    this.salidaEliminar = true;
  }

  /**
   * Elimina la salida seleccionada o cancela la operación, refrescando la lista, la información del lote
   * y los totales al finalizar.
   * @param cancelar - Indicador que determina si se cancela la eliminación.
   */
  deleteSalida( cancelar: string ) {
    this.salidaEliminar = false;
    if ( cancelar ) {
      return;
    }
    this.loading = true;
    this.loader = true;
    this.loteCabotaje.deleteCabotageOutput(this.cuurentOutputId)
    .pipe(
      switchMap( _ => {
        this.loader = false;
        return this.loteCabotaje.getListByBatchCabotageOutput(this.bacthId)
      })
    ).subscribe({
      next: outputs => {
        this.loteCabotaje.getCabotageBatch(this.bacthId)
        .subscribe({
          next: batch => {
            this.loteCabotaje.loteInfoCabotage = batch[0];
            if (outputs.length) {
              outputs = this.idToName(outputs);
              // outputs = this.fieldDate(outputs);
            }
            this.updateTotals(outputs);
            outputs = [...this.sortArrayDesc<ExportOutput>(outputs, 'id')];
            this.loteCabotaje.cabotageOutputs = [...outputs];
            this.loteCabotaje.cabotageOutputsFilter = [...outputs];
            this.loader = false;
            this.loading = false;
            this.mensaje = 'Salida eliminada correctamente';
            this.icon = 'bi bi-check2';
            this.overlay = true;
            setTimeout(() => {
              this.overlay = false;
            }, 2000);
          },
          error: (e) => {
            this.loader = false;
            this.loading = false;
            this.icon = 'bi bi-exclamation-circle-fill';
            this.mensaje = 'Error en el servidor al actualizar el lote, inténtelo más tarde';
            this.overlay = true;
            setTimeout(() => {
              this.overlay = false;
            }, 3000);
          },
        });
      },
      error: (e) => {
        this.loader = false;
        this.loading = false;
        this.icon = 'bi bi-exclamation-circle-fill';
        this.mensaje = 'Error en el servidor al eliminar el registro, inténtelo más tarde';
        this.overlay = true;
        setTimeout(() => {
          this.overlay = false;
        }, 3000);
      },
    });
  }

  /**
   * Muestra el detalle o la edición de una salida, validando permisos y cargando la información
   * correspondiente según el tipo de salida (barco, transporte, merma, acuerdo aduanal, etc.).
   * @param info - Información de la salida (identificador y tipo de salida).
   * @param accion - Acción a realizar ('detalle' o 'actualizar').
   */
  mostrarSalida(info: infoSalida, accion: string) {
    if (accion === 'detalle') {
      this.subtitulo = 'Detalle de salida';
      this.movimiento = 'detalle';
      if (!this.authService.isValidPath('cabotage', 'outputs', 'consult')) {
        return;
      }
    } else {
      this.subtitulo = 'Editar salida';
      this.movimiento = 'actualizar';
      if (!this.authService.isValidPath('cabotage', 'outputs', 'update')) {
        return;
      }
    }
    this.loaderOverlay = true;
    this.overlaySalida = true;
    if (info.tipoSalida === 1) {
      this.tipoSalida = 1;
      this.loteCabotaje.getCabotageOutput(info.id)
      .subscribe({
        next: output => {
          this.outputDetail = [...output];
          this.loaderOverlay = false;
        },
        error: (e) => {
          this.loaderOverlay = false;
          this.icon = 'bi bi-exclamation-circle-fill';
          this.mensaje = 'Error en el servidor al cargar la salida, inténtelo más tarde';
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          }, 3000);
        },
      });
    } else if (info.tipoSalida === 2) {
      this.tipoSalida = 2;
      forkJoin([
        this.loteCabotaje.getCabotageOutput(info.id),
        this.loteCabotaje.getCabotageTransportListByOutput(info.id),
      ]).subscribe({
        next: ([
          output,
          transports
        ]) => {
          this.outputDetail = [...output];
          this.transportList = [...transports];
          this.loaderOverlay = false;
        },
        error: (e) => {
          this.loaderOverlay = false;
          this.icon = 'bi bi-exclamation-circle-fill';
          this.mensaje = 'Error en el servidor al cargar la salida, inténtelo más tarde';
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          }, 3000);
        },
      });
    } else if (info.tipoSalida === 3) {
      this.tipoSalida = 3;
      forkJoin([this.loteCabotaje.getCabotageOutput(info.id), this.loteCabotaje.getCabotageOutputMermaFile(info.id)])
      .subscribe({
        next: ([output, outputFile]) => {
          this.outputDetail = [...output];
          this.archivos.oficioMerma = outputFile.url;
          this.loaderOverlay = false;
        },
        error: (e) => {
          this.loaderOverlay = false;
          this.icon = 'bi bi-exclamation-circle-fill';
          this.mensaje = 'Error en el servidor al cargar la salida, inténtelo más tarde';
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          }, 3000);
        },
      });
    } else if (info.tipoSalida === 4) {
      this.tipoSalida = 4;
      this.loteCabotaje.getCabotageOutput(info.id)
      .subscribe({
        next: output => {
          this.outputDetail = [...output];
          this.loaderOverlay = false;
        },
        error: (e) => {
          this.loaderOverlay = false;
          this.icon = 'bi bi-exclamation-circle-fill';
          this.mensaje = 'Error en el servidor al cargar la salida, inténtelo más tarde';
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          }, 3000);
        },
      });
    } else if (info.tipoSalida === 5) {
      this.tipoSalida = 5;
      this.loteCabotaje.getCabotageOutput(info.id)
      .subscribe({
        next: output => {
          this.outputDetail = [...output];
          this.loaderOverlay = false;
        },
        error: (e) => {
          this.loaderOverlay = false;
          this.icon = 'bi bi-exclamation-circle-fill';
          this.mensaje = 'Error en el servidor al cargar la salida, inténtelo más tarde';
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          }, 3000);
        },
      });
    } else {
      this.tipoSalida = 6;
      forkJoin([
        this.loteCabotaje.getCabotageOutput(info.id),
        this.loteCabotaje.getCabotageTransportListByOutput(info.id),
        this.loteCabotaje.getCabotageOutputAgreementFile(info.id)
      ]).subscribe({
        next: ([
          output,
          transports,
          outputFile
        ]) => {
          this.outputDetail = [...output];
          this.transportList = [...transports];
          if (outputFile.url) {
            this.archivos.acuerdoAduanal = outputFile.url;
          }
          this.loaderOverlay = false;
        },
        error: (e) => {
          this.loaderOverlay = false;
          this.icon = 'bi bi-exclamation-circle-fill';
          this.mensaje = 'Error en el servidor al cargar la salida, inténtelo más tarde';
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          }, 3000);
        },
      });
    }
  }

  /**
   * Descarga el documento asociado a una salida según su tipo, mostrando mensajes cuando no aplica.
   * @param ouputInfo - Información de la salida cuyo documento se descarga.
   */
  downloadFile(ouputInfo: infoSalida) {
    if (ouputInfo.tipoSalida === 4 || ouputInfo.tipoSalida === 1) {
      this.message = 'Esta salida no tiene archivo';
      this.file = true;
      setTimeout(() => {
        this.file = false;
      }, 1500);
    } else {
      this.loading = true;
      if (ouputInfo.tipoSalida === 2 || ouputInfo.tipoSalida === 6) {
        const currentOutput = this.loteCabotaje.cabotageOutputs.find(output => output.id === ouputInfo.id);
        if (ouputInfo.tipoSalida === 6 && currentOutput && !currentOutput.transport_type_id) {
          this.loading = false;
          this.mensaje = 'Esta salida no tiene transportes';
          this.icon = 'bi bi-info-circle-fill';
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          }, 3000);
          return;
        }
        const cabotage = 3;
        this.loteService.getTransportOrderExpCab(cabotage, ouputInfo.id)
        .subscribe({
          next: output => {
            this.loading = false;
            if (output.url) {
              window.open(output.url, '_blank')
            } else {
              this.message = 'Error al descargar la orden de transporteo';
              this.file = true;
              setTimeout(() => {
                this.file = false;
              }, 2000);
            }
          },
          error: (e) => {
            this.loading = false;
            this.icon = 'bi bi-exclamation-circle-fill';
            this.mensaje = 'Error en el servidor al descargar el archivo, inténtelo más tarde';
            this.overlay = true;
            setTimeout(() => {
              this.overlay = false;
            }, 3000);
          },
        });
        return;
      }
      this.loteCabotaje.getCabotageOutputMermaFile(ouputInfo.id)
      .subscribe({
        next: output => {
          this.loading = false;
          if (output.url) {
            window.open(output.url, '_blank');
          } else {
            this.message = 'Esta salida no tiene asignado un archivo';
            this.file = true;
            setTimeout(() => {
              this.file = false;
            }, 1500);
          }
        },
        error: (e) => {
          this.loading = false;
          this.icon = 'bi bi-exclamation-circle-fill';
          this.mensaje = 'Error en el servidor al descargar el archivo, inténtelo más tarde';
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          }, 3000);
        },
      });
    }
  }

  /**
   * Cierra el overlay de detalle y recarga las salidas del lote, actualizando los totales.
   */
  closeDetalle() {
    this.loteCabotaje.getListByBatchCabotageOutput(this.bacthId)
    .subscribe({
      next: outputs => {
        if (outputs.length) {
          outputs = this.idToName(outputs);
        }
        this.updateTotals(outputs);
        outputs = [...this.sortArrayDesc<ExportOutput>(outputs, 'id')];
        this.loteCabotaje.cabotageOutputs = [...outputs];
        this.loteCabotaje.cabotageOutputsFilter = [...outputs];      this.loader = false;
      },
      error: (e) => {
        this.icon = 'bi bi-exclamation-circle-fill';
        this.mensaje = 'Error en el servidor al cargar las salidas, inténtelo más tarde';
        this.overlay = true;
        setTimeout(() => {
          this.overlay = false;
        }, 3000);
      },
    });
    this.overlaySalida = false;
  }

  /**
   * Convierte los identificadores de catálogo de cada salida en sus nombres descriptivos según el tipo de salida.
   * @param salidas - Lista de salidas a transformar.
   * @returns La lista de salidas con los nombres descriptivos asignados.
   */
  idToName(salidas: ExportOutput[]) {
    return salidas.map( salida => {
      if (salida.output_type_option_id == 1) {
        const objOutputType = this.outputTypes.find( tipo => tipo.id == salida.output_type_option_id);
        salida.outputDescription = objOutputType?.description || '';
        const objCountry = this.nationalPorts.find( nationalPort => nationalPort.id == salida.destination_id);
        salida.destination_id = objCountry!.description;
        if (!salida.checker_name) {
          salida.checker_name = 'No asignado.';
        }
        return salida;
      } else if(salida.output_type_option_id == 2) {
        const objOutputType = this.outputTypes.find( tipo => tipo.id == salida.output_type_option_id);
        salida.outputDescription = objOutputType?.description || '';
        salida.destination_id = salida.destiny;
        salida.ship_number = 'No aplica.';
        salida.ship_name = 'No aplica.';
        return salida;
      } else if(salida.output_type_option_id == 3) {
        const objOutputType = this.outputTypes.find( tipo => tipo.id == salida.output_type_option_id);
        salida.outputDescription = objOutputType?.description || '';
        salida.destination_id = 'No aplica.';
        salida.checker_name = 'No aplica.';
        salida.ship_number = salida.ship_number || 'No aplica.';
        return salida;
      } else if(salida.output_type_option_id == 4) {
        const objOutputType = this.outputTypes.find( tipo => tipo.id == salida.output_type_option_id);
        salida.outputDescription = objOutputType?.description || '';
        salida.destination_id = 'No aplica.';
        salida.ship_number = 'No aplica.';
        salida.ship_name = 'No aplica.';
        salida.checker_name = 'No aplica.';
        return salida;
      } else if(salida.output_type_option_id == 5) {
        const objOutputType = this.outputTypes.find( tipo => tipo.id == salida.output_type_option_id);
        salida.outputDescription = objOutputType?.description || '';
        salida.destination_id = 'No aplica.';
        salida.ship_number = 'No aplica.';
        salida.ship_name = 'No aplica.';
        return salida;
      } else if(salida.output_type_option_id == 6) {
        const objOutputType = this.outputTypes.find( tipo => tipo.id == salida.output_type_option_id);
        salida.outputDescription = objOutputType?.description || '';
        salida.destination_id = 'No aplica.';
        salida.ship_number = 'No aplica.';
        salida.ship_name = 'No aplica.';
        return salida;
      } else {
        return salida;
      }
    });
  }

  /**
   * Recorta las fechas de salida al formato `YYYY-MM-DD`.
   * @param array - Lista de salidas cuyas fechas se formatean.
   * @returns La lista de salidas con las fechas formateadas.
   */
  fieldDate(array: ExportOutput[]): ExportOutput[] {
    array.forEach(element => {
      element.departure_date = element.departure_date !== null ? element.departure_date.substring(0, 10) : element.departure_date;
    });
    return array;
  }

  /**
   * Ordena un arreglo de manera descendente según la clave indicada.
   * @param array - Arreglo de elementos a ordenar.
   * @param key - Clave del elemento por la cual se ordena.
   * @returns El arreglo ordenado de forma descendente.
   */
  sortArrayDesc<T>(array: T[], key: keyof T): T[] {
    return array.sort(function (a, b) {
      if (b[key] < a[key]) {
        return -1;
      }
      if (b[key] > a[key]) {
        return 1;
      }
      return 0;
    });
  }

  /**
   * Ordena un arreglo según la clave indicada.
   * @param array - Arreglo de elementos a ordenar.
   * @param key - Clave del elemento por la cual se ordena.
   * @returns El arreglo ordenado.
   */
  sortArray<T>(array: T[], key: keyof T): T[] {
    return array.sort(function (a, b) {
      if (b[key] < a[key]) {
        return -1;
      }
      if (b[key] > a[key]) {
        return 1;
      }
      return 0;
    });
  }

  /**
   * Calcula y actualiza el total de tonelaje de las salidas, excluyendo las de tipo 5.
   * @param outputs - Lista de salidas sobre la que se calcula el total.
   */
  updateTotals(outputs: ExportOutput[]) {
    this.table_config.totals!.total = outputs.reduce( (previous, current) => {
      if (current.output_type_option_id !== 5) {
        return previous + Number(current.total_tonnage)
      } else {
        return previous;
      }
    }, 0);
  }

}
